jQuery( '.page-template-template-news .press-feed .grid-x' ).masonry({
  // options
columnWidth: '.large-6',
itemSelector: '.press',
percentPosition: true
});

jQuery(window).on('load', function() { 
	
	jQuery( '.page-template-template-news .press-feed .grid-x' ).masonry();
	
});